<i *ngFor="let star of stars; let i = index" [ngClass]="color[i]"  (click)="setRating(i)"></i>
<!--(mouseover)="changeStyle($event,i)" (mouseout)="changeStyle($event,i)"-->
